/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Input
} from "reactstrap";
import BorderedTable from "../../../shared/components/table/BorderedTable";
import ViewCompanyPage from "../../ViewCompanyPage/components/viewCompany";
// import Pagination from "../../../shared/components/pagination/Pagination";
import {
  getAllCompanies,
  getMoreCompanies,
  getThisCompany,
  getCompanyByEmail
} from "../../../redux/middlewares/Company/getCompany";
import { toast } from "react-toastify";

export default class DataTable extends PureComponent {
  constructor() {
    super();
    this.heads = [
      {
        key: "SNo",
        name: "#",
        width: 80
      },
      {
        key: "id",
        name: "Id",
        width: 80
      },
      {
        key: "name",
        name: "Name",
        sortable: true
      },
      {
        key: "email",
        name: "Email",
        sortable: true
      },
      {
        key: "website",
        name: "Website",
        sortable: true
      },
      {
        key: "jobs",
        name: "Jobs",
        sortable: true
      },
      {
        key: "action",
        name: "Action",
        sortable: true
      }
    ];

    // const initialPageNumber = 1;
    // const initialRowsCount = 10;

    // // const minRows = 20;
    // // const maxRows = 41;
    // // const rowsCount = Math.random() * (maxRows - minRows);
    // const originalRows = [];
    // const currentPageRows = this.filterRows(
    //   originalRows,
    //   initialPageNumber,
    //   initialRowsCount
    // );

    this.state = {
      rows: undefined,
      rowsPerPage: 20,
      page: 1,
      companies: undefined,
      loading: true,
      initialLimit: 20,
      moreData: false,
      lastVisible: undefined,
      clickedCompany: undefined,
      isOpen: false,
      searchQuery: "",
      searchKeyword: ""
    };
  }

  callInitialData = () => {
    getAllCompanies({ limit: this.state.initialLimit })
      .then(docs => {
        // console.log(docs);
        if (!docs.empty) {
          const { rowsPerPage, page } = { ...this.state };
          let companies = [];
          docs.forEach(job => companies.push({ ...job.data(), id: job.id }));
          let moreData =
            companies.length < this.state.rowsPerPage ? false : true;
          // Checking for last data retrive
          let lastVisible = docs.docs[docs.docs.length - 1];
          this.setState({ moreData, companies, lastVisible }, () =>
            this.createRows(rowsPerPage, page)
          );
        } else {
          this.setState({
            loading: false,
            moreData: false,
            companies: undefined
          });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.callInitialData();
  }

  onChangePage = pageToGo => {
    const { page, rowsPerPage, companies } = this.state;
    // IF Data is Already avaliable direct render it.
    if (pageToGo < page || companies.length > pageToGo * rowsPerPage) {
      this.setState({ page: pageToGo, moreData: true }, () =>
        this.createRows(rowsPerPage, pageToGo)
      );
    }
    // Else call from Database.
    else if (pageToGo > page) {
      this.callMoreData();
    }
  };

  callMoreData = () => {
    const { rowsPerPage, companies, lastVisible, page } = this.state;
    if (lastVisible) {
      // this.setState({ loading: true });
      getMoreCompanies({ limit: rowsPerPage, startAfter: lastVisible }).then(
        snap => {
          if (!snap.empty) {
            const newData = [];
            snap.forEach(docs => newData.push({ ...docs.data(), id: docs.id }));
            let allData = [...companies, ...newData];
            //  Check if the entry is already available
            const uniqueData = Array.from(new Set(allData.map(a => a.id))).map(
              id => {
                return allData.find(a => a.id === id);
              }
            );
            // Checking for last data retrive
            let lastVisible = snap.docs[snap.docs.length - 1];
            // let moreData = rowsPerPage * (page + 1) < uniqueData.length;
            this.setState(
              {
                loading: false,
                companies: uniqueData,
                lastVisible
                // moreData
              },
              () => this.createRows(rowsPerPage, page + 1)
            );
          } else {
            this.setState({ moreData: false, page: page + 1 });
          }
        }
      );
    }
  };

  fromSecondsToDate = seconds => new Date(seconds * 1000).toLocaleDateString();

  // Make the arrangement Same As heads
  createRows = () => {
    const rows = [];
    // const that = this;
    const companies = [...this.state.companies];

    try {
      for (let i = 0; i < companies.length; i++) {
        // console.log(i);

        rows.push({
          sno: i + 1,
          id: companies[i].id, //companies[i].id,
          name: companies[i].name,
          email: companies[i].email,
          website: companies[i].websiteURL,
          // date: this.fromSecondsToDate(companies[i].postedAt.seconds),
          jobs: companies[i].jobsPosted
        });
      }
    } catch (error) {
      console.error(error);
    }

    // setTimeout(() => {
    //   console.log(rows);
    // }, 300);

    this.setState({ rows, loading: false });
  };

  filterRows = (originalRows, pageNumber, rowsOnPage) => {
    const rowsFrom = rowsOnPage * (pageNumber - 1);
    const rowsTo = rowsFrom + rowsOnPage;
    return originalRows.slice(rowsFrom, rowsTo);
  };

  toggleModal = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  };

  onRowClickHandler = id => {
    const filter = this.state.companies.filter(e => e.id === id);
    if (filter.length > 0)
      this.setState({ clickedCompany: filter[0] }, this.toggleModal());
  };

  // CLear state (Reinitialize)
  onClearState = () => {
    this.setState({
      rows: undefined,
      rowsPerPage: 10,
      page: 1,
      companies: undefined,
      loading: true,
      initialLimit: 10,
      moreData: false,
      lastVisible: undefined,
      clickedCompany: undefined,
      isOpen: false,
      searchQuery: "",
      searchKeyword: ""
    });
  };

  // Search Handler
  searchFilterHandler = () => {
    let query = this.state.searchKeyword;
    if (query && query.length > 0) {
      this.setState({ loading: true, searchQuery: query, companies: [] });
      getCompanyByEmail({ limit: this.state.initialLimit, email: query })
        .then(docs => {
          // console.log(docs);
          if (!docs.empty) {
            const { rowsPerPage, page } = { ...this.state };
            let companies = [];
            docs.forEach(com => companies.push({ ...com.data(), id: com.id }));
            // let moreData = companies.length > this.state.rowsPerPage;
            // Checking for last data retrive
            let lastVisible = docs.docs[docs.docs.length - 1];
            this.setState({ companies, lastVisible }, () =>
              this.createRows(rowsPerPage, page)
            );
          } else {
            this.setState(
              {
                loading: false,
                moreData: false,
                companies: []
              },
              () => this.createRows()
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false, searchQuery: "" });
          toast.error(error.message);
        });
    }
  };

  onClearFilters = () => {
    this.onClearState();
    this.callInitialData();
  };

  render() {
    const {
      rows,
      moreData,
      page,
      loading,
      searchKeyword,
      searchQuery
    } = this.state;
    // console.log(rows);

    return (
      <Col md={12} lg={12}>
        <Card>
          {this.state.clickedCompany && (
            <Modal
              isOpen={this.state.isOpen}
              toggle={this.toggleModal}
              className="edit-job-modal"
            >
              <ModalHeader toggle={this.toggleModal}>Company</ModalHeader>
              <ModalBody>
                <ViewCompanyPage
                  company={this.state.clickedCompany}
                  isModalView
                />
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.toggleModal} size="sm">
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <CardBody>
            <Row>
              <Col md={4}></Col>
              <Col sm={12} md={4}>
                <form onSubmit={this.searchFilterHandler}></form>
                <Row>
                  <Col md={9} style={{ paddingRight: "0px" }}>
                    <Input
                      type="search"
                      placeholder="Company email"
                      value={searchKeyword}
                      onChange={e =>
                        this.setState({ searchKeyword: e.target.value })
                      }
                      style={{ borderRadius: "0px" }}
                    />
                  </Col>
                  <Col md={3} style={{ paddingLeft: "0px" }}>
                    <Button
                      color="primary"
                      style={{ height: "2.4rem", borderRadius: "0px" }}
                      onClick={this.searchFilterHandler}
                    >
                      Search
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col md={4}></Col>
            </Row>
            {searchQuery && (
              <Row>
                <Col sm={1} style={{ display: "flex", alignItems: "center" }}>
                  <div className="card__title" style={{ marginBottom: "0px" }}>
                    <h5 className="bold-text">Search:</h5>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="filters-list">
                    {/* <h5>Search: </h5> */}
                    <li>
                      <span style={{ minWidth: "100%" }}>
                        {this.state.searchQuery}
                      </span>

                      <img
                        src={require("../../../assets/images/close.png")}
                        alt="close"
                        onClick={() => this.onClearFilters()}
                      />
                    </li>
                  </div>
                </Col>
              </Row>
            )}

            {/* Previous */}
            <div
              style={{
                height: "400px",
                overflow: "auto",
                border: "1px solid #efefef  ",
                // display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {loading ? (
                <h3
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  Loading...
                </h3>
              ) : Array.isArray(rows) && rows.length > 0 ? (
                <BorderedTable
                  heads={this.heads}
                  rows={rows}
                  path="companies"
                  onRowClickHandler={this.onRowClickHandler}
                  moreDataAvailable={this.state.moreData}
                  callMoreData={this.callMoreData}
                />
              ) : (
                <h2
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  No Data Found.
                </h2>
              )}
            </div>

            {/* <Row style={{ margin: "1vw .2vw" }}>
              <Col sm={6}>
                <Button
                  color="primary"
                  size="sm"
                  disabled={page === 1}
                  onClick={() => this.onChangePage(page - 1)}
                >
                  Prev
                </Button>
              </Col>
              <Col sm={6} style={{ textAlign: "end" }}>
                <Button
                  color="primary"
                  size="sm"
                  disabled={!moreData}
                  onClick={() => this.onChangePage(page + 1)}
                >
                  Next
                </Button>
              </Col>
            </Row> */}
            {/* <Pagination
              itemsCount={rows.length}
              itemsToShow={itemsToShow}
              pageOfItems={pageOfItems}
              onChangePage={this.onChangePage}
            /> */}
          </CardBody>
        </Card>
      </Col>
    );
  }
}
